var React = require('react');

function Pin (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M20.688 11c0 5.525-9.844 20.667-9.844 20.667S1 16.525 1 11C1 5.477 5.406 1 10.844 1c5.436 0 9.844 4.477 9.844 10zm-5.907 0c0 2.21-1.764 4-3.937 4-2.175 0-3.938-1.79-3.938-4 0-2.208 1.763-4 3.938-4 2.173 0 3.937 1.792 3.937 4z","stroke":"#394043","strokeWidth":"2","fill":"#fff","fillRule":"evenodd","strokeLinejoin":"round"}));
}

Pin.defaultProps = {"width":"22","height":"33","viewBox":"0 0 22 33"};

module.exports = Pin;

Pin.default = Pin;
